import {
  Alert,
  FormControl,
  FormHelperText,
  Radio,
  RadioGroup,
  // FormControlLabel,
} from "@mui/material";
import React, { useEffect } from "react";
import Parser from "html-react-parser";
import * as style from "./style";
import { Typography } from "@mui/material";
import { selectedResetQuizGroup } from "../../store/courseTestSelector";
import { setResetQuizGroup } from "../../store/courseTestSlice";
import { useDispatch, useSelector } from "react-redux";

const Question = ({
  number,
  test,
  getValue,
  show,

  radio,
  numberOfTries,
  falseAnswer,
  correctAnswer,
  sessionName,
}) => {
  const dispatch = useDispatch();

  // @Selector
  const resetQuizGroup = useSelector(selectedResetQuizGroup);

  const [value, setValue] = React.useState("");
  const [error, setError] = React.useState("الرجاء اختيار اجابة");

  useEffect(() => {
    if (resetQuizGroup == true) {
      setValue("");
      dispatch(setResetQuizGroup(false));
    }
  }, [resetQuizGroup]);
  useEffect(() => {
    if (typeof window?.MathJax !== "undefined") {
      window.MathJax.typesetClear();
      window.MathJax.typeset();
    }
  }, []);
  const handleChange = (event, index) => {
    setValue(event.target.value);
    getValue(event.target.value, test.id, error);
    if (event.target.value !== "") setError("");
  };

  let answersFalse = falseAnswer.filter((el) => el.question_id === test.id);
  let answersTrue = correctAnswer.filter((el) => el.question_id === test.id);

  function editString(s) {
    let ans = "";
    for (let i = 0; i < s.length; i++) {
      if (s.charAt(i) == "<") {
        let j = i;
        while (j < s.length && s.charAt(j) != ">") j++;
        i = j;
      } else ans += s.charAt(i);
    }
    return ans;
  }

  function isArabic() {
    const unicode = sessionName.charCodeAt(0);
    return (
      (unicode >= 0x0600 && unicode <= 0x06ff) ||
      (unicode >= 0x0750 && unicode <= 0x077f) ||
      (unicode >= 0x08a0 && unicode <= 0x08ff) ||
      (unicode >= 0xfb50 && unicode <= 0xfdff) ||
      (unicode >= 0xfe70 && unicode <= 0xfeff)
    );
  }

  return (
    <div
      style={{
        margin: " 0 0 32px 0",
        padding: "32px 48px",
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
      dir={isArabic() ? "rtl" : "ltr"}
    >
      <FormControl key={test.id}>
        <style.FormLabelCus id="demo-controlled-radio-buttons-group">
          <Typography>{`${number} - `}</Typography>{" "}
          <Typography>{Parser(test.question)}</Typography>
        </style.FormLabelCus>

        <RadioGroup name={radio} value={value} onChange={handleChange}>
          <style.FormLabelControlCus
            chek={value}
            value="1"
            not={numberOfTries}
            result={answersFalse}
            control={<Radio />}
            label={
              !test.answer1.includes("\\")
                ? Parser(test.answer1)
                : editString(test.answer1)
            }
            correctAnswerId={answersTrue}
            correctId={answersTrue[0]?.question_id}
            testId={test.id}
            disabled={answersTrue.length > 0 || answersFalse.length > 0}
          />
          <style.FormLabelControlCus
            chek={value}
            value="2"
            not={numberOfTries}
            result={answersFalse}
            control={<Radio />}
            label={
              !test.answer2.includes("\\")
                ? Parser(test.answer2)
                : editString(test.answer2)
            }
            correctAnswerId={correctAnswer}
            testId={test.id}
            disabled={answersTrue.length > 0 || answersFalse.length > 0}
          />
          {test.answer3 && (
            <style.FormLabelControlCus
              not={numberOfTries}
              result={answersFalse}
              chek={value}
              value="3"
              control={<Radio />}
              label={
                !test.answer3.includes("\\")
                  ? Parser(test.answer3)
                  : editString(test.answer3)
              }
              correctAnswerId={correctAnswer}
              testId={test.id}
              disabled={answersTrue.length > 0 || answersFalse.length > 0}
            />
          )}
          {test.answer4 && (
            <style.FormLabelControlCus
              not={numberOfTries}
              result={answersFalse}
              chek={value}
              value="4"
              control={<Radio />}
              label={
                !test.answer4.includes("\\")
                  ? Parser(test.answer4)
                  : editString(test.answer4)
              }
              correctAnswerId={correctAnswer}
              testId={test.id}
              disabled={answersTrue.length > 0 || answersFalse.length > 0}
            />
          )}
        </RadioGroup>
        {show && (
          <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>
        )}
        {answersFalse.length > 0 && numberOfTries >= 0 && (
          <Alert style={{ width: "10rem" }} severity="error">
            إجابتك خاطئة
          </Alert>
        )}

        {answersTrue.length > 0 && numberOfTries >= 0 && (
          <Alert style={{ width: "10rem" }} severity="success">
            إجابتك صحيحة
          </Alert>
        )}
      </FormControl>
    </div>
  );
};

export default Question;
